export default __webpack_public_path__ + "static/Lifeguard-0198ef76339db47e884b98e238574d2d.mp3";